module.exports = {
  "country": "GE",
  "artist": "Nina Sublatti",
  "song": "Warrior",
  "year": "2015",
  "place": "11",
  "spotify": "7yU7FlMnnLHEnOVxMmQLCQ"
};